module.exports = __webpack_public_path__ + "static/media/login-blue-bg.a1b0e269.png";